module.exports = __webpack_public_path__ + "static/top-center-a7a4a773b2fea0a268481e5d7e9def90.png";